<template>
  <modal
    class="hid-setup-modal"
    :title="modal.title"
    :description="modal.description"
    :loading="loading"
    @cancel="closeModal"
  >
    <p
      v-if="hasHIDCredetials"
      class="hid-setup-modal--success"
    >
      HID Origo Integration has successfully been configured.
    </p>
    <div class="hid-setup-modal-form">
      <div class="form-container">
        <label class="form-label">Organization ID</label>
        <input
          v-model="hidForm.customerId"
          :disabled="hasHIDCredetials"
          class="form-field"
          type="text"
        />
      </div>
      <div class="form-container">
        <label class="form-label">Client ID</label>
        <input
          v-model="hidForm.clientId"
          :disabled="hasHIDCredetials"
          class="form-field"
          type="text"
        />
      </div>
      <div class="form-container">
        <label class="form-label">Client Secret</label>
        <input
          v-model="hidForm.clientSecret"
          :disabled="hasHIDCredetials"
          class="form-field"
          type="text"
        />
      </div>
    </div>
    <template #footer>
      <div class="hid-setup-modal-footer">
        <img
          class="hid-setup-modal-footer__logo"
          :src="hidLogo"
        />
        <div class="hid-setup-modal-footer__buttons">
          <template v-if="hasHIDCredetials">
            <button
              v-if="hasHIDCredetials"
              id="resync-hid-setup-modal"
              class="btn btn__text mr-1 hid-setup-modal__resync"
              :disabled="loading"
              @click="startSyncEvent(hidCredential.uuid)"
            >
              Re-Sync
            </button>
            <button
              v-if="hasHIDCredetials"
              id="activate-hid-setup-modal"
              class="btn btn--red"
              :disabled="loading"
              @click="deleteHIDCredential"
            >
              Delete Credential
            </button>
          </template>
          <template v-else>
            <button
              id="cancel-hid-setup-modal"
              class="btn btn--grey mr-1"
              @click="closeModal"
            >
              Cancel
            </button>
            <button
              id="activate-hid-setup-modal"
              class="btn"
              :disabled="loading"
              @click="createHIDCredential"
            >
              Activate
            </button>
          </template>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modal'

import credentialQueries from '@/graphql/credentials.js'
import syncEventQueries from '@/graphql/syncEvents.js'

import {AUTH_TYPES} from '@/mixins/authenticatorMixin'
import hidLogo from '@/assets/logos/logo-hid.png'

export default {
  name: 'HIDSetupModal',
  components: {Modal},
  mixins: [credentialQueries, syncEventQueries],
  data() {
    return {
      loading: false,
      hidCredential: null,
      hidLogo: hidLogo,
      modal: {
        title: 'Configure HID Origo Integration',
        description:
          'With the HID Credential, users can authenticate entirely from their mobile device without a card.',
      },
      hidForm: {
        clientId: '',
        clientSecret: '',
        customerId: '',
      },
    }
  },
  computed: {
    hasHIDCredetials() {
      return Boolean(this.hidCredential)
    },
  },
  created() {
    this.fetchCredentials()
  },
  methods: {
    async fetchCredentials() {
      try {
        this.loading = true
        const {credentialsList} = await this.listCredentialsQuery({
          page: 1,
          perPage: 10,
        })
        this.hidCredential = credentialsList.find((credential) => {
          return credential.type === AUTH_TYPES.HID
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async createHIDCredential() {
      try {
        this.loading = true
        const _credential = {
          name: 'HID Mobile Credential',
          description: 'This is the HID mobile credential.',
          url: 'www.hid.com',
          type: AUTH_TYPES.HID,
          rawData: this.hidForm,
        }
        const {uuid} = await this.createCredentialMutation(_credential)
        await this.startSyncEvent(uuid)
        this.displayAlert('success', 'HID Origo Integration has been activated.')
        this.closeModal()
      } catch (error) {
        if (error.message.includes('credential already exists')) {
          this.displayAlert('fail', 'The credentials you\'ve entered already exist.')
        } else {
          this.displayAlert('fail', 'Unable to validate configuration.')
        }
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async deleteHIDCredential() {
      try {
        this.loading = true
        await this.deleteCredentialMutation(this.hidCredential.uuid)
        this.displayAlert('success', 'Successfully removed HID Origo credential.')
        this.closeModal()
      } catch (error) {
        this.displayAlert('fail', 'Unable to delete the credential.')
      } finally {
        this.loading = false
      }
    },
    async startSyncEvent(hidCredentialID) {
      try {
        const payload = {
          credentialUUID: hidCredentialID,
          startTime: new Date().toISOString(),
        }
        await this.createSyncMutation(payload)
        this.displayAlert('success', 'Sync event has successfully been queued.')
      } catch (error) {
        this.displayAlert('fail', 'Unable to start sync.')
        throw error
      }
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.hid-setup-modal {
  &-footer {
    @include flex-display();
    @include flex-justify-content(space-between);
    @include flex-align-items(flex-end);
    width: 100%;
    margin-top: 2em;
    flex-grow: 1;
    @media #{$mobile} {
      @include flex-justify-content(space-between);
    }
    &__logo {
      width: 100px;
      height: auto;
    }
  }
  &--success {
    color: $green;
    font-weight: 600;
    margin: 0;
    margin-bottom: 1.5em;
  }
  &__resync {
    color: $dark-grey;
  }
}
</style>
